/* LB-014 winner (Coframe variant 6a98a9eb3e8b9f0144e324da), part 2 of 2: "Best Sellers" in the slide-out menu, after its first item.
   Desktop visitors only (the test's audience; it lost on mobile). Part 1 is snippets/best-sellers-nav-item.liquid in the desktop nav.
   Safe alongside Coframe: skips if the link is already there. */
(function () {
  var ID = 'cf-best-sellers-mobile';
  var es = (window.Shopify && window.Shopify.locale === 'es') || location.pathname.indexOf('/es-es') === 0;
  var label = es ? 'Los Más Vendidos' : 'Best Sellers';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function add() {
    if (document.getElementById(ID)) return true;
    var list = document.querySelector('#slideout-mobile-navigation .js-accordion-mobile-nav.c-accordion--mobile-nav');
    if (!list) return false;
    var li = document.createElement('li'); li.id = ID;
    var a = document.createElement('a'); a.className = 'js-accordion-link c-accordion__link';
    a.href = root + 'collections/top-designer-fragrances'; a.textContent = label;
    li.appendChild(a);
    var first = list.querySelectorAll(':scope > li')[0];
    if (first && first.nextElementSibling) list.insertBefore(li, first.nextElementSibling); else list.appendChild(li);
    return true;
  }
  if (!add()) {
    var mo = new MutationObserver(function () { if (add()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }
})();
